import { BORDER_RADIUS } from "Constants/theme";

export const styles = {
  appointmentComparison: {
    display: "flex",
    gap: "24px",
    flexDirection: { xs: "column", md: "row" },
    boxSizing: "border-box",
  },
  appointmentBox: {
    width: "100%",
    p: 2,
    boxSizing: "border-box",
    borderRadius: BORDER_RADIUS,
    backgroundColor: "background.paper",
    boxShadow: 5,
  },
  actionButtons: {
    display: "flex",
    justifyContent: { xs: "center", sm: "flex-end" },
    marginTop: "16px",
  },
  responseStack: {
    justifyContent: "center",
    alignItems: "center",
  },
  responseMessage: {
    fontSize: "18px",
    fontWeight: "500",
    textAlign: "center",
  },
};
